// There are a few places where the side2 is still handled in editor.js.erb
// and new_editor.js.erb, particularly with image handling.

import Cache from 'admin/editor/cache';
import { debounce } from 'vendor/lodash.debounce';
import Side2PlaceHolder from 'images/side2_placeholder1.gif';
import PlaceHolderStripes from 'images/placeholder_stripes.gif';
import A11yDialog from "a11y-dialog";

export default class Side2Element {
  constructor(options) {
    this.learnEditor = options.editor;
    this.savedText = null;
    this.savedImages = null;
    this.activeElementId = null;
    this.activePosition = null;
    this.replacedImage = null;

    this.init();

    $(document).on('mouseenter', '.build-side-wrapper .small-side', function() {
      $('.side-image-options', this).css('visibility', 'visible');

    }).on('mouseleave', '.build-side-wrapper .small-side', function() {
      $('.side-image-options', this).css('visibility', 'hidden');
    });
  }

  init() {
    const ua = navigator.userAgent
    this.action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on(this.action, '.add-build-side', this.newElement.bind(this));
    $(document).on(this.action, '.submit-build-side', this.submitElement.bind(this));
    $(document).on(this.action, '.cancel-build-side', this.cancelElement.bind(this));
    $(document).on(this.action, '.delete-build-side', this.deleteElement.bind(this));
    $(document).on(this.action, '.split-build-side', this.splitElement.bind(this));
    $(document).on(this.action, '.build-side, .build-side a', this.editElement.bind(this));
    $(document).on(this.action, '.convert-image-side2-element', this.convertImageToSide2.bind(this));
    $(document).on(this.action, '.convert-crop-cancel', this.cancelCrop.bind(this));
    $(document).on(this.action, '.remove-asset', this.deleteImage.bind(this));
    $(document).on(this.action, '.cancel_overlay_asset', this.editModalCancel.bind(this));
    $(document).on(this.action, '.edit-side-image', this.editImage.bind(this));
    $(document).on('ajax:success', '.convert_asset', this.handleConvertImageCrop.bind(this));
    $(document).on('ajax:success', '.edit_asset', this.handleEditModalSuccess.bind(this));


    this.cache = new Cache('side2');
  }

  shouldShowButton() {
    return $('input[name="page_type"]').val() !== 'user';
  }

  addButtonTemplate() {
    return '<a class="add-build-side" href="#"><i class="fa fa-th-large"></i>Side&#178;</a>';
  }

  newElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.savedText = null;

    const cachedText = this.cache.get('text');

    this.insertSideBySide(link.closest('.button-bar, .bottom-button-bar'), cachedText);
    this.learnEditor.editing();
  }

  submitElement(event) {
    event.preventDefault();
    const $element = $(event.currentTarget).closest('.build-side-wrapper');
    const text = tinymce.activeEditor.getContent();
    const gallery = $element.find('.image-gallery');

    //don't allow saving of the side-by-side row unless there is text and an image
    if (!text || gallery.find('.small-side').length == 0) {
      alert('Add text and image to save, or click cancel to exit.');
      return;
    }

    this.learnEditor.disable_text_editor($('.build-textarea'));

    this.savedText = null;
    this.replaceSideBySide($element, text, gallery, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Added Side-by-Side Element");
  }

  editElement(event) {
    event.preventDefault();
    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    let $element = $(event.currentTarget);

    if ($element.is('a')) {
      $element = $element.parents('.build-side');
    }

    const cachedText = this.cache.get('text');

    //backup the text and images text, save it in case of cancelling
    this.savedText =  $element.find('.side-text .text').html();
    this.savedImages = $element.find('.image-gallery').clone();
    this.activeElementId = $element.closest('.build-side').attr('id');
    this.activePosition = $element.closest('.build-side').data('position');

    this.addEditor($element, cachedText || this.savedText, this.savedImages.html());
    this.learnEditor.centerInView($('.build-side-wrapper'));
    this.learnEditor.editing();
  }

  cancelElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    this.learnEditor.disable_text_editor($('.build-textarea'));

    //restore with global saved data
    this.replaceSideBySide($element.closest('.build-side-wrapper'),
      this.savedText,
      this.savedImages,
      this.activeElementId,
      this.activePosition);

    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.finishEditing();
    this.cache.delete();
  }

  deleteElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);


    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    this.learnEditor.disable_text_editor($('.build-textarea'));

    this.activeElementId = "";
    this.activePosition = "";

    $element.parents('.build-side-wrapper').remove();
    this.learnEditor.save_page("Before Deleted  Side-by-Side Element");

    this.cache.delete();
  }

  splitElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);


    if (!confirm("This will split the images and text of this elements into individual elements.  Are you sure you want to do this?")) {
      return;
    }

    this.learnEditor.disable_text_editor($('.build-textarea'));

    var elementId =
    this.learnEditor.editing();
    $.ajax({
      url: $('#editor-form').attr("action") + "/elements/" + this.activeElementId.split("-")[1] + "/split",
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify(this.learnEditor.formData("Before Split  Side-by-Side Element")),
      dataType: 'json'
    }).done(this.learnEditor.save_response.bind(this.learnEditor)).fail(this.learnEditor.save_response.bind(this.learnEditor));


    this.activeElementId = "";
    this.activePosition = "";

    this.cache.delete();
  }

  insertSideBySide($element, text) {
    $element.replaceWith(this.buildSideBySide(text, ""));

    this.learnEditor.enable_text_editor($('#editor'));
    this.image_upload_side();
    this.watchState();
  }

  watchState($element) {
    var saveState = function(event) {
      var text = tinymce.activeEditor.getContent();
      this.cache.save({ text: text });
    }

    tinymce.activeEditor.on('keyup', debounce(saveState.bind(this), 500));
  }

  buildSideBySide(text, imagesHTML) {
    text = text || "";
    text = text.replace(/'/g, "&#39;").trim();

    let buildText = [
      "<div class='build-side-wrapper'>",
        "<div class='content'>",
          "<div class='side-images'>",
            "<div class='image-gallery'>",
              `${imagesHTML}`,
            "</div>",
            `${imagesHTML.length ? this.additionalFileUploadButton() : this.firstFileUploadButton()}`,
          "</div>",
          "<div class='side-text'>",
            "<div class='table-editor'>",
              `<textarea id='editor' class='build-textarea' style='display=block;'>${text}</textarea>`,
            "</div>",
          "</div>",
        "</div>",
        "<div class='editor-buttons'>",
          "<button class='delete-build-side delete'>Delete</button>",
          "<button class='cancel-build-side cancel'>Cancel</button>",
          "<button class='submit-build-side save'>Save</button>",
        "</div>",
      "</div>"
      ].join('\n');

    let $buildText = $(buildText);

    if (this.activeElementId) {
      $buildText.find('.delete-build-side').before("<button class='split-build-side destructive-option'>Split</button>");
    }

    return $buildText;
  }

  replaceSideBySide($element, text, $imageGallery, id, position) {
    if (!text || $imageGallery.find('.small-side').length == 0) {
      $element.remove();

      return;
    }

    let displayImage = $imageGallery.find('.small-side').first().find('img')[0].outerHTML;
    let buildElement =
      `<div id='${id || ''}' class='element side-element build-side' data-position='${position}'>
        <div class='side-images'>
          <div class='side-image-display'>
            ${displayImage}
          </div>
          <div class='image-gallery'>
            ${$imageGallery.html()}
          </div>
        </div>
        <div class='side-text'>
          <div class='text'>
            ${text}
          </div>
        </div>
      </div>`;

    let $buildRow = $(buildElement);

    if ($imageGallery.find('.small-side').length == 1) {
      $buildRow.find('.image-gallery').addClass("hide");
    }

    $('.side-image-options', $buildRow).remove();
    $element.replaceWith($buildRow);
  }

  addEditor($element, text, imageElementsHTML) {
    let $buildText = $(this.buildSideBySide(text, imageElementsHTML));

    $element.replaceWith($buildText);

    this.learnEditor.enable_text_editor($('#editor'));
    this.image_upload_side();
    this.prepend_build_row_image_modifiers($('.build-side-wrapper'));
    this.watchState();
  }

  //side2 image modifiers
  prepend_build_row_image_modifiers($element) {
    var $small_images = $element.find('.small-side');

    var link = [
      '<div class="side-image-options">',
        '<div><a href="#" class="edit-side-image">edit</a></div>',
        '<div class="fileinput-button replace-button">replace<input class="replace-side-image" type="file" name="files"></div>',
        '<div><a href="#" class="remove-asset">remove</a></div>',
      '</div>'
    ];

    $small_images.each(function(i, image) {
      $(image).prepend(link.join(''));
    });

    this.replaceImageListeners();
    $element.find('.image-gallery').sortable({
      opacity: 0.6,
      cursor: 'move',
      tolerance: 'pointer',
      forcePlaceholderSize: true
    });
  }

  editImage(event) {
    event.preventDefault();

    var $img = $(event.target).parents('.small-side').find('a img')
    var that = this;
    var asset = parseInt($img.attr('class'), 10);
    var url =  '/pages/' + this.learnEditor.pageID + '/assets/' + asset + "/edit";

    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'html'
    }).done(function(data) {
      that.cropImage(data);
    });
  }

  replaceImageListeners() {
    $.cleanData('.replace-side-image');

    var that = this;
    $('.replace-side-image').fileupload({
      dataType: 'html',
      progressInterval: 20,
      bitrateInterval: 100,
      dropZone: null,
      add: function(e, data) {
        var url, asset, $container, page_id = $('input[name$="page_id"]').val();
        var $img = $(this).closest('.small-side').find('img');
        asset = parseInt($img.attr('class'), 10);
        url = '/pages/' + page_id + '/assets/' + asset + '/replace?update_type=side';
        data.url = url;

        that.replacedImage = $(this).closest('.small-side').clone();
        $(".image-upload-button").hide();
        $(this).closest('.small-side').replaceWith(that.build_image_placeholder);

        data.submit();
      },
      done: function (e, data) {
        var result = $(data.result)[0];
        if ($(result).is('#cropModal')) {
          that.$replace_image_element = $(this);
          that.cropImage(data.result);
        } else {
          $(".image-uploading").replaceWith(data.result);
          that.showImageUploadButtons();
          that.image_upload_side();
        }
      }
    });
  }

  handleEditModalSuccess(event, data, status, xhr) {
    var response = xhr.responseText;
    var $result = $(response);

    this.dialog.hide();

    // contense in if shoulg go elswhere not the else
    if ($(response).is('.table-image')) {
      $('.active-image-upload-container').html($result).removeClass('active-image-upload-container');

      this.prepend_table_image_modifiers();
    } else {

      $(".image-uploading").replaceWith(response);

      this.showImageUploadButtons();
      this.image_upload_side();
      this.prepend_build_row_image_modifiers($('.build-side-wrapper'));
    }
  }

  editModalCancel(event) {
    event.preventDefault();

    if ($('#asset_update_type').val() !== 'edit') { //don't delete if editing
      var that = this;

      $.ajax({
        type: "DELETE",
        url: $(event.target).attr('href')
      }).done(function( msg ) {
        that.dialog.hide();

        $(".image-uploading").replaceWith(that.replacedImage);
        that.showImageUploadButtons();
        that.image_upload_side();

        that.enableEditor();
      });
    } else {
      this.dialog.hide();
    }
  }

  image_upload_side() {
    var that = this;
    var page_id = $('input[name$="page_id"]').val();
    var post_url = '/pages/' + page_id + '/assets/create_side_image';
    $('#image-input').fileupload({
      dataType: 'html',
      url: post_url,
      progressInterval: 20,
      bitrateInterval: 100,
      add: function(e, data) {
        $(".image-upload-button").hide();
        $(".image-gallery", '.build-side-wrapper').append(that.build_image_placeholder);
        var $element = $(this).closest('img');
        data.submit();
      },
      done: function (e, data) {
        if ($(data.result).is('#cropModal')) {
          that.cropImage(data.result);
        } else {
          $(".image-uploading").replaceWith(data.result);
          that.showImageUploadButtons();
          that.image_upload_side();
        }
      }
    });
  }

  build_image_placeholder() {
    return `<img src="${PlaceHolderStripes}" class="image-uploading" />`
  }

  convertImageToSide2(event) {
    event.preventDefault();

    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    if (!confirm("Confirm conversion of this image to side2. This is not reversible.")) {
      return;
    }

    this.$convertElement = $(event.currentTarget).closest(".build-image");
    let $image = this.$convertElement.find("img");
    const assetId = parseInt($image.prop('class'), 10);
    const pageId = $('input[name$="page_id"]').val();
    const url = `/pages/${pageId}/assets/${assetId}/side_build`;

    this.savedText = $('.side-text .text', this.$convertElement).html();

    this.activeElementId = this.$convertElement.attr('id');
    this.activePosition = this.$convertElement.data('position');

    $.post(url, function(data) {
      if ($(data).is('#cropModal')) {
        this.cropImage(data);
      }
    }.bind(this));
  }

  handleConvertImageCrop(event, data, status, xhr) {
    this.dialog.hide();
    this.addEditor(this.$convertElement, this.savedText, $(data).prop('outerHTML'));
    this.learnEditor.centerInView($('.build-side-wrapper'));
    this.learnEditor.editing();
  }

  deleteImage(event, data, status, xhr) {
    let $link = $(event.currentTarget);

    $link.closest('.small-side').remove()
  }

  cropImage(result) {
    $("#page-editor").after(result);
    const dialogElement = document.querySelector('#cropModal')
    
    this.dialog = new A11yDialog(dialogElement);
    this.dialog.show();
  }

  cancelCrop(event) {
    event.preventDefault();
    this.dialog.hide();
  }

  showImageUploadButtons() {
    if ($('.small-side', '.build-side-wrapper').length == 0) {
      $('.image-upload-button').replaceWith(this.firstFileUploadButton());
    } else {
      $('.image-upload-button').replaceWith(this.additionalFileUploadButton());
    }
  }

  firstFileUploadButton() {
    return [
      "<div class='image-upload-button fileinput-button side2-image-placeholder-first'>",
        `<img class='medium-placeholder' src='${Side2PlaceHolder}' alt=''>`,
        "<input id='image-input' type='file' name='files'>",
      "</div>"
    ].join('');
  }

  additionalFileUploadButton() {
    return [
      "<div class='image-upload-button fileinput-button side2-image-placeholder-additional'>",
        "<button class='side2-upload-additional-image-button editor-button'><i class='fa fa-camera'></i>Upload Image</button>",
        "<input id='image-input' name='files' type='file'>",
      "</div>"
    ].join('');
  }
}
